import { render } from "./NThumbnail.vue?vue&type=template&id=268e26a2&ts=true"
import script from "./NThumbnail.vue?vue&type=script&lang=ts"
export * from "./NThumbnail.vue?vue&type=script&lang=ts"

import "./NThumbnail.vue?vue&type=style&index=0&id=268e26a2&lang=stylus"

import exportComponent from "/tmp/ffsecurity-ui/packages/v2/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__